var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExtendedFamily(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1212.86 752.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a193b3da-ca32-4fe2-8533-26af3ef4b134 {\n        fill: #f4beb2;\n      }\n\n      .e6d1b3b6-668d-4a1f-aa12-d7ffa9008091 {\n        fill: #ee6e51;\n      }\n\n      .e1443cf0-912d-4600-a620-a6d4463da31b {\n        fill: #231f20;\n      }\n\n      .a06a5c7a-1320-4040-bd73-2ba9f7592d7f, .a0fc879a-3486-4fa4-b098-48d40753e19e, .a3379629-1197-4a42-a184-ef9060cb9c2f, .a615e823-a398-4d53-9b12-86459fb2ce52, .afee8757-e023-471b-9325-5d980bdde616, .b3af4a95-c0bc-407a-a633-b885cf333d64, .f41a863a-6f5c-40d2-9f54-41949b923797 {\n        fill: none;\n      }\n\n      .afe40199-54b8-4b01-bc96-1211e2fb0886 {\n        fill: #92d4cd;\n      }\n\n      .a06a5c7a-1320-4040-bd73-2ba9f7592d7f, .a0fc879a-3486-4fa4-b098-48d40753e19e, .a3379629-1197-4a42-a184-ef9060cb9c2f, .a615e823-a398-4d53-9b12-86459fb2ce52, .afee8757-e023-471b-9325-5d980bdde616, .f41a863a-6f5c-40d2-9f54-41949b923797 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .a615e823-a398-4d53-9b12-86459fb2ce52 {\n        stroke-width: 6.14px;\n      }\n\n      .f41a863a-6f5c-40d2-9f54-41949b923797 {\n        stroke-width: 6.24px;\n      }\n\n      .afee8757-e023-471b-9325-5d980bdde616 {\n        stroke-width: 7.27px;\n      }\n\n      .a0fc879a-3486-4fa4-b098-48d40753e19e {\n        stroke-width: 5.75px;\n      }\n\n      .a3379629-1197-4a42-a184-ef9060cb9c2f {\n        stroke-width: 5.93px;\n      }\n\n      .a06a5c7a-1320-4040-bd73-2ba9f7592d7f {\n        stroke-width: 6.21px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ExtendedFam") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "adb08e45-ab47-4e22-bafa-9513aea921b8",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e2cb3a72-0780-4168-83a8-c1361556c51c",
    "data-name": "colour"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a193b3da-ca32-4fe2-8533-26af3ef4b134",
    d: "M365.5,29.47,362.6,8.3c-.55-4-5.73-6.59-8.81-4.34L330.87,20.65a4.86,4.86,0,0,1-4,.67L300,15c-4.29-1-7.07,2.89-4.73,6.62l14.29,22.77a4.84,4.84,0,0,1,.66,4l-8.94,29.05c-1.12,3.64,3,7.71,7,6.93l23.33-4.6a6.29,6.29,0,0,1,5.86,2.31l15.87,19.5c2.83,3.48,8.14,3.11,9-.62l3.14-32.76a3.8,3.8,0,0,1,1.67-2.34l30-13.62c3.24-2.05,1.86-7.2-2.34-8.74l-25.22-9.27A6.3,6.3,0,0,1,365.5,29.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a193b3da-ca32-4fe2-8533-26af3ef4b134",
    d: "M938,28.12l-7.6,9.17c-1.27,1.52-.65,3.8,1.05,3.87L946,39.7a1.72,1.72,0,0,1,1.17.53l8.49,11.86c1.18,1.23,3.29.18,3.6-1.78l1.74-11a2.78,2.78,0,0,1,1.74-2.19l10-3.44c1.71-.58,2.37-3.06,1.13-4.2l-9.9-9.14a2.21,2.21,0,0,1-.63-1.68l.41-11.91a1.88,1.88,0,0,0-3.29-1.48l-8.89,8.38a2.16,2.16,0,0,1-1.68.63L937.32,13c-1.68-.18-3.1,2-2.41,3.62l3.6,8.76A2.8,2.8,0,0,1,938,28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a193b3da-ca32-4fe2-8533-26af3ef4b134",
    d: "M865.93,62.34l7.73-9.06c1.28-1.51.7-3.79-1-3.89l-14.53,1.26a1.71,1.71,0,0,1-1.16-.54l-8.33-12c-1.15-1.24-3.28-.23-3.62,1.73l-1.9,11A2.79,2.79,0,0,1,841.36,53l-10,3.29c-1.71.56-2.41,3-1.19,4.19l9.77,9.28a2.17,2.17,0,0,1,.62,1.68L840,83.35a1.88,1.88,0,0,0,3.27,1.53l9-8.26a2.21,2.21,0,0,1,1.69-.61l12.48,1.47c1.68.2,3.12-1.91,2.46-3.59l-3.48-8.81A2.79,2.79,0,0,1,865.93,62.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e6d1b3b6-668d-4a1f-aa12-d7ffa9008091",
    d: "M1029.6,524l3.31-8.36c.62-1.59-.75-3.6-2.34-3.41l-11.85,1.39a2,2,0,0,1-1.6-.57l-8.56-7.85a1.78,1.78,0,0,0-3.1,1.45l.55,11.3a2,2,0,0,1-.58,1.6l-9.28,8.81c-1.16,1.11-.5,3.45,1.13,4l9.5,3.13a2.66,2.66,0,0,1,1.68,2.06l1.79,10.43c.32,1.86,2.35,2.82,3.44,1.63l7.92-11.37a1.58,1.58,0,0,1,1.09-.51l13.81,1.19c1.61-.09,2.16-2.26.94-3.69l-7.34-8.6A2.66,2.66,0,0,1,1029.6,524Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a193b3da-ca32-4fe2-8533-26af3ef4b134",
    d: "M1113.48,658.84l21-4.44c4-.85,6.19-6.24,3.72-9.17l-18.42-21.78a4.91,4.91,0,0,1-1-4l4.36-27.41c.69-4.37-3.42-6.88-7-4.26l-21.81,16a4.9,4.9,0,0,1-4,1l-29.81-6.87c-3.73-.87-7.52,3.54-6.44,7.49l6.3,23.08a6.29,6.29,0,0,1-1.89,6l-18.42,17.35c-3.28,3.09-2.53,8.39,1.27,9l33.12.77a3.87,3.87,0,0,1,2.47,1.51l15.83,29.09c2.3,3.1,7.36,1.34,8.61-3l7.47-26A6.3,6.3,0,0,1,1113.48,658.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a193b3da-ca32-4fe2-8533-26af3ef4b134",
    d: "M137.82,552l24.12-5.1c4.59-1,7.1-7.15,4.26-10.5l-21.11-25a5.64,5.64,0,0,1-1.11-4.54l5-31.42c.8-5-3.91-7.89-8-4.89l-25,18.34a5.65,5.65,0,0,1-4.54,1.09l-34.18-7.88c-4.28-1-8.62,4.07-7.39,8.6l7.23,26.46a7.23,7.23,0,0,1-2.17,6.94L53.79,544c-3.76,3.54-2.9,9.62,1.46,10.34l38,.89A4.37,4.37,0,0,1,96.05,557l18.16,33.35c2.63,3.56,8.44,1.54,9.86-3.42l8.57-29.79A7.25,7.25,0,0,1,137.82,552Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e6d1b3b6-668d-4a1f-aa12-d7ffa9008091",
    d: "M153.11,690.27l3.48-8.8c.67-1.68-.78-3.79-2.46-3.6l-12.48,1.47a2.15,2.15,0,0,1-1.68-.6l-9-8.27a1.88,1.88,0,0,0-3.27,1.53l.58,11.9a2.14,2.14,0,0,1-.62,1.69l-9.76,9.28c-1.23,1.16-.53,3.62,1.18,4.19l10,3.29a2.79,2.79,0,0,1,1.77,2.17l1.89,11c.34,2,2.47,3,3.62,1.72l8.34-12a1.63,1.63,0,0,1,1.15-.54L160.38,706c1.7-.09,2.29-2.37,1-3.89L153.65,693A2.81,2.81,0,0,1,153.11,690.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e6d1b3b6-668d-4a1f-aa12-d7ffa9008091",
    d: "M626.25,394.21a6.47,6.47,0,0,0-9-5.12l-29.78,13.06a11.79,11.79,0,0,0-20.05-5.37L542.14,375a5.6,5.6,0,0,0-8.92,2.37c-8.27,23-8.24,37.72-6.86,45.83a6.46,6.46,0,0,0,9.22,4.72L567,412.54a11.76,11.76,0,0,0,13.73,3.16l27.69,26a5.59,5.59,0,0,0,9-2C626.68,417,627.29,402.37,626.25,394.21Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e1443cf0-912d-4600-a620-a6d4463da31b",
    cx: 10.15,
    cy: 405.74,
    rx: 9.35,
    ry: 11.12,
    transform: "translate(-263.73 106.21) rotate(-41.01)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e1443cf0-912d-4600-a620-a6d4463da31b",
    cx: 1151.86,
    cy: 427.32,
    rx: 11.12,
    ry: 9.35,
    transform: "translate(2.24 860.63) rotate(-41.01)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e1443cf0-912d-4600-a620-a6d4463da31b",
    cx: 228.23,
    cy: 258.77,
    r: 11.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e1443cf0-912d-4600-a620-a6d4463da31b",
    cx: 98.07,
    cy: 293.39,
    r: 11.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e1443cf0-912d-4600-a620-a6d4463da31b",
    cx: 1034.03,
    cy: 293.3,
    r: 11.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e1443cf0-912d-4600-a620-a6d4463da31b",
    cx: 886.42,
    cy: 275.64,
    r: 11.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3af4a95-c0bc-407a-a633-b885cf333d64",
    d: "M257.07,345.43S289,342.3,292.3,310.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e6d1b3b6-668d-4a1f-aa12-d7ffa9008091",
    d: "M261.8,437.07a23.3,23.3,0,0,0,4.89-22.75c-.1-.32-.21-.63-.33-.94a8.43,8.43,0,0,0-9.91-5.31l-29.57,7.29a7.45,7.45,0,0,0-5.7,7.62,23.31,23.31,0,0,0,23.43,21.83h0l1.18,33.09a9.11,9.11,0,0,0,5,7.8l30.15,15.48a5.19,5.19,0,0,0,7.52-3.93l4.46-33.53a11.07,11.07,0,0,0-5.21-10.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3af4a95-c0bc-407a-a633-b885cf333d64",
    d: "M524.55,555.76S520,695.18,508.47,746.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3af4a95-c0bc-407a-a633-b885cf333d64",
    d: "M579,555.76s11.89,159.11,22.67,192.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3af4a95-c0bc-407a-a633-b885cf333d64",
    d: "M837.15,588.69s-12.66,118.08-27.74,152.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3af4a95-c0bc-407a-a633-b885cf333d64",
    d: "M906.21,597.16s.88,108.89-8.46,144.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3af4a95-c0bc-407a-a633-b885cf333d64",
    d: "M314.77,549.91s22.87,136.94,46.57,193.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3af4a95-c0bc-407a-a633-b885cf333d64",
    d: "M275.74,566.89s-10.46,100.56,34.49,176.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e6d1b3b6-668d-4a1f-aa12-d7ffa9008091",
    d: "M1084.15,159.23c-2.59-4.31-8.94-5.83-17.2-4.82,1.34-6.79.46-12.21-3-15-8.11-6.56-27.31,3.72-42.87,23-.75.93-2.55,3.38-3.25,4.31,13.92,9.2,25.57,19.92,34.94,33.27l1.25-.72C1075.23,186.48,1089.52,168.18,1084.15,159.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e6d1b3b6-668d-4a1f-aa12-d7ffa9008091",
    d: "M781.16,146.32c3-4.06,9.42-5,17.56-3.26-.73-6.89.63-12.21,4.33-14.69,8.66-5.82,26.87,6.13,40.66,26.69.66,1,2.24,3.6,2.85,4.58-14.68,7.92-27.24,17.57-37.77,30-.39-.28-.78-.54-1.17-.83C787.62,174.26,775,154.76,781.16,146.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3af4a95-c0bc-407a-a633-b885cf333d64",
    d: "M1065,376.23a13.5,13.5,0,0,0,22.28-6.77,13.46,13.46,0,0,0,7.63,2.36,16.13,16.13,0,0,0,14.12-9.4,14,14,0,0,0-.59,3.86,13.53,13.53,0,1,0,27.06,0c0-.32,0-.63,0-.94a22.35,22.35,0,0,0,17.92,8.44c12.4-.22,22.07-10.77,22-23.17a40.7,40.7,0,0,0-.31-5.33c2.32,8.49,11.5,14.4,20.79,12.73a17.31,17.31,0,0,0,9.3-29h0a17.37,17.37,0,0,0-4.8-3.51,35.2,35.2,0,0,1-7.41-4.73c-10.93-9.42-34.17-25.87-40-59.58-9.65-55.23-100.12-61.23-100.12-61.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3af4a95-c0bc-407a-a633-b885cf333d64",
    d: "M1010.67,184.2a32.85,32.85,0,1,1-48.93,28.65c0-25.47,25.12-25.47,25.12,0A32.85,32.85,0,1,1,932.5,188"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3af4a95-c0bc-407a-a633-b885cf333d64",
    d: "M435.85,184.37c14.9-11.29,31.32-15.4,48.77-14.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3af4a95-c0bc-407a-a633-b885cf333d64",
    d: "M690.46,174.61c-16-6.08-33.75-6.17-52.61-2.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3af4a95-c0bc-407a-a633-b885cf333d64",
    d: "M533.11,239c24.59,13.75,50.35,10.89,76.71-.48"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e6d1b3b6-668d-4a1f-aa12-d7ffa9008091",
    x1: 244.61,
    y1: 444.81,
    x2: 261.8,
    y2: 437.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "e6d1b3b6-668d-4a1f-aa12-d7ffa9008091",
    x1: 283.97,
    y1: 450.57,
    x2: 275.46,
    y2: 498.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e6d1b3b6-668d-4a1f-aa12-d7ffa9008091",
    x1: 270.81,
    y1: 442.56,
    x2: 261.8,
    y2: 491.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "e6d1b3b6-668d-4a1f-aa12-d7ffa9008091",
    x1: 257.07,
    y1: 439.21,
    x2: 247.63,
    y2: 483.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "e6d1b3b6-668d-4a1f-aa12-d7ffa9008091",
    x1: 226.24,
    y1: 436.06,
    x2: 266.31,
    y2: 429.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "e6d1b3b6-668d-4a1f-aa12-d7ffa9008091",
    x1: 221.33,
    y1: 421.02,
    x2: 267.32,
    y2: 416.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3af4a95-c0bc-407a-a633-b885cf333d64",
    d: "M316.55,433.69s103.08-49.95,193-35.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3af4a95-c0bc-407a-a633-b885cf333d64",
    d: "M638.75,409.32s132.94-24.54,210.3,40.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3af4a95-c0bc-407a-a633-b885cf333d64",
    d: "M815.53,412.12S712.3,388.65,638.75,433.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3af4a95-c0bc-407a-a633-b885cf333d64",
    d: "M512.44,413.29s-121.2-24-205.14-11.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3af4a95-c0bc-407a-a633-b885cf333d64",
    d: "M944.64,351.45s12.83,23.18,37.8,1.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3af4a95-c0bc-407a-a633-b885cf333d64",
    d: "M775.15,246.61A159.49,159.49,0,1,1,963.84,452.42h0s-12.54,4.18-15,27.67c-4.31,29,4.8,118.49-75.8,119.12S842.88,489.77,846,472.57s4.93-30.25.69-37h0A159.53,159.53,0,0,1,775.15,246.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3af4a95-c0bc-407a-a633-b885cf333d64",
    d: "M50.45,289.42a159.49,159.49,0,1,1,261.26,98.52h0s-9.31,9.39-.92,31.47C320,447.19,368.55,523,296.9,559.92s-76.28-84.06-81.3-100.8-9.24-29.22-16.07-33.34h0A159.55,159.55,0,0,1,50.45,289.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3af4a95-c0bc-407a-a633-b885cf333d64",
    d: "M759.75,216.6c0-104-84.3-188.29-188.29-188.29A188.32,188.32,0,0,0,507.1,393.6h0c6.71,8.19,5.37,13.46,5.35,19.69a50,50,0,0,1-3.62,18.18c-16,40.49-6.58,87.46-6.58,87.46h0a50.91,50.91,0,0,0,73.21,38.74h0s.26-.12.75-.39a50.87,50.87,0,0,0,10.45-7.24c18.79-15.3,54.37-56.2,51.53-145.16a26.67,26.67,0,0,1,14.08-18.19h0A188.3,188.3,0,0,0,759.75,216.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3af4a95-c0bc-407a-a633-b885cf333d64",
    d: "M808.79,189.67s-36.13,9.41-49,26.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3af4a95-c0bc-407a-a633-b885cf333d64",
    d: "M783.61,368.53c-2.49,11.32-31.56,4.93-29.07-6.4,0,8.23-33.72,8.23-33.72,0q-13.52,5.34-18-10.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3af4a95-c0bc-407a-a633-b885cf333d64",
    d: "M206.27,433.69S103.5,459.3,10.15,408.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3af4a95-c0bc-407a-a633-b885cf333d64",
    d: "M955.32,460s124.63,21.08,196.54-29.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "afe40199-54b8-4b01-bc96-1211e2fb0886",
    d: "M728.79,506.42c-3.18-11.95.2-25.06,8.43-32.7l72.6-67.41A160.18,160.18,0,0,1,770,329.05l-38.54-13.16a189.1,189.1,0,0,1-79.18,70.81h0a26.67,26.67,0,0,0-14.08,18.19c2.84,89-32.74,129.86-51.53,145.16a50.87,50.87,0,0,1-10.45,7.24c-.49.27-.75.39-.75.39h0a50.91,50.91,0,0,1-73.21-38.74h0s-9.44-47,6.58-87.46a50,50,0,0,0,3.62-18.18c0-6.23,1.36-11.5-5.35-19.69h0a188.94,188.94,0,0,1-97-80l-56.3,18.24a160.43,160.43,0,0,1-38.9,53.29,28.55,28.55,0,0,0,5.13,6.67L412,480c8.11,7.77,11.29,20.93,7.92,32.83l-36.67,129.7c-6.54,23.11,11.41,45.28,30.53,37.71l153.42-87.13a20.26,20.26,0,0,1,15.41.12l152,89.55c19,7.87,37.29-14,31.12-37.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a193b3da-ca32-4fe2-8533-26af3ef4b134",
    d: "M687.85,540.13l-15.63-22.06c-2.6-3.68-8-3.67-9.1,0l-5.36,32.69a3.83,3.83,0,0,1-1.84,2.24l-31,11.65c-3.39,1.85-2.35,7.1,1.77,8.93l23.11,10.3a6.33,6.33,0,0,1,3.78,5.09l1.66,23.87c.28,4.09,5.31,7,8.56,4.95l25.87-16.31a4.86,4.86,0,0,1,4.05-.41L719.59,609c4.23,1.29,7.29-2.43,5.19-6.33l-13.15-24.44a4.88,4.88,0,0,1-.4-4.05l10.2-26.64c1.37-3.58-2.47-7.95-6.53-7.43l-21.32,2.74A6.3,6.3,0,0,1,687.85,540.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "f16018a6-4f0a-410f-9c9f-8cab69a85ae7",
    "data-name": "line art"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a615e823-a398-4d53-9b12-86459fb2ce52",
    d: "M626.25,394.21a6.47,6.47,0,0,0-9-5.12l-29.78,13.06a11.79,11.79,0,0,0-20.05-5.37L542.14,375a5.6,5.6,0,0,0-8.92,2.37c-8.27,23-8.24,37.72-6.86,45.83a6.46,6.46,0,0,0,9.22,4.72L567,412.54a11.76,11.76,0,0,0,13.73,3.16l27.69,26a5.59,5.59,0,0,0,9-2C626.68,417,627.29,402.37,626.25,394.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f41a863a-6f5c-40d2-9f54-41949b923797",
    d: "M938,28.12l-7.6,9.17c-1.27,1.52-.65,3.8,1.05,3.87L946,39.7a1.72,1.72,0,0,1,1.17.53l8.49,11.86c1.18,1.23,3.29.18,3.6-1.78l1.74-11a2.78,2.78,0,0,1,1.74-2.19l10-3.44c1.71-.58,2.37-3.06,1.13-4.2l-9.9-9.14a2.21,2.21,0,0,1-.63-1.68l.41-11.91a1.88,1.88,0,0,0-3.29-1.48l-8.89,8.38a2.16,2.16,0,0,1-1.68.63L937.32,13c-1.68-.18-3.1,2-2.41,3.62l3.6,8.76A2.8,2.8,0,0,1,938,28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f41a863a-6f5c-40d2-9f54-41949b923797",
    d: "M865.93,62.34l7.73-9.06c1.28-1.51.7-3.79-1-3.89l-14.53,1.26a1.71,1.71,0,0,1-1.16-.54l-8.33-12c-1.15-1.24-3.28-.23-3.62,1.73l-1.9,11A2.79,2.79,0,0,1,841.36,53l-10,3.29c-1.71.56-2.41,3-1.19,4.19l9.77,9.28a2.17,2.17,0,0,1,.62,1.68L840,83.35a1.88,1.88,0,0,0,3.27,1.53l9-8.26a2.21,2.21,0,0,1,1.69-.61l12.48,1.47c1.68.2,3.12-1.91,2.46-3.59l-3.48-8.81A2.79,2.79,0,0,1,865.93,62.34Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e1443cf0-912d-4600-a620-a6d4463da31b",
    cx: 10.15,
    cy: 405.74,
    rx: 9.35,
    ry: 11.12,
    transform: "translate(-263.73 106.21) rotate(-41.01)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e1443cf0-912d-4600-a620-a6d4463da31b",
    cx: 1151.86,
    cy: 427.32,
    rx: 11.12,
    ry: 9.35,
    transform: "translate(2.24 860.63) rotate(-41.01)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e1443cf0-912d-4600-a620-a6d4463da31b",
    cx: 228.23,
    cy: 258.77,
    r: 11.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e1443cf0-912d-4600-a620-a6d4463da31b",
    cx: 98.07,
    cy: 293.39,
    r: 11.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e1443cf0-912d-4600-a620-a6d4463da31b",
    cx: 1034.03,
    cy: 293.3,
    r: 11.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e1443cf0-912d-4600-a620-a6d4463da31b",
    cx: 886.42,
    cy: 275.64,
    r: 11.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "afee8757-e023-471b-9325-5d980bdde616",
    d: "M257.07,345.43S289,342.3,292.3,310.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a0fc879a-3486-4fa4-b098-48d40753e19e",
    d: "M261.8,437.07a23.3,23.3,0,0,0,4.89-22.75c-.1-.32-.21-.63-.33-.94a8.43,8.43,0,0,0-9.91-5.31l-29.57,7.29a7.45,7.45,0,0,0-5.7,7.62,23.31,23.31,0,0,0,23.43,21.83h0l1.18,33.09a9.11,9.11,0,0,0,5,7.8l30.15,15.48a5.19,5.19,0,0,0,7.52-3.93l4.46-33.53a11.07,11.07,0,0,0-5.21-10.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "afee8757-e023-471b-9325-5d980bdde616",
    d: "M524.55,555.76S520,695.18,508.47,746.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "afee8757-e023-471b-9325-5d980bdde616",
    d: "M579,555.76s11.89,159.11,22.67,192.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "afee8757-e023-471b-9325-5d980bdde616",
    d: "M837.15,588.69s-12.66,118.08-27.74,152.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "afee8757-e023-471b-9325-5d980bdde616",
    d: "M906.21,597.16s.88,108.89-8.46,144.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "afee8757-e023-471b-9325-5d980bdde616",
    d: "M314.77,549.91s22.87,136.94,46.57,193.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "afee8757-e023-471b-9325-5d980bdde616",
    d: "M275.74,566.89s-10.46,100.56,34.49,176.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a0fc879a-3486-4fa4-b098-48d40753e19e",
    d: "M1084.15,159.23c-2.59-4.31-8.94-5.83-17.2-4.82,1.34-6.79.46-12.21-3-15-8.11-6.56-27.31,3.72-42.87,23-.75.93-2.55,3.38-3.25,4.31,13.92,9.2,25.57,19.92,34.94,33.27l1.25-.72C1075.23,186.48,1089.52,168.18,1084.15,159.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a0fc879a-3486-4fa4-b098-48d40753e19e",
    d: "M781.16,146.32c3-4.06,9.42-5,17.56-3.26-.73-6.89.63-12.21,4.33-14.69,8.66-5.82,26.87,6.13,40.66,26.69.66,1,2.24,3.6,2.85,4.58-14.68,7.92-27.24,17.57-37.77,30-.39-.28-.78-.54-1.17-.83C787.62,174.26,775,154.76,781.16,146.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a0fc879a-3486-4fa4-b098-48d40753e19e",
    d: "M1065,376.23a13.5,13.5,0,0,0,22.28-6.77,13.46,13.46,0,0,0,7.63,2.36,16.13,16.13,0,0,0,14.12-9.4,14,14,0,0,0-.59,3.86,13.53,13.53,0,1,0,27.06,0c0-.32,0-.63,0-.94a22.35,22.35,0,0,0,17.92,8.44c12.4-.22,22.07-10.77,22-23.17a40.7,40.7,0,0,0-.31-5.33c2.32,8.49,11.5,14.4,20.79,12.73a17.31,17.31,0,0,0,9.3-29h0a17.37,17.37,0,0,0-4.8-3.51,35.2,35.2,0,0,1-7.41-4.73c-10.93-9.42-34.17-25.87-40-59.58-9.65-55.23-100.12-61.23-100.12-61.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a0fc879a-3486-4fa4-b098-48d40753e19e",
    d: "M1010.67,184.2a32.85,32.85,0,1,1-48.93,28.65c0-25.47,25.12-25.47,25.12,0A32.85,32.85,0,1,1,932.5,188"
  }), /*#__PURE__*/React.createElement("path", {
    className: "afee8757-e023-471b-9325-5d980bdde616",
    d: "M435.85,184.37c14.9-11.29,31.32-15.4,48.77-14.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "afee8757-e023-471b-9325-5d980bdde616",
    d: "M690.46,174.61c-16-6.08-33.75-6.17-52.61-2.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "afee8757-e023-471b-9325-5d980bdde616",
    d: "M533.11,239c24.59,13.75,50.35,10.89,76.71-.48"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a0fc879a-3486-4fa4-b098-48d40753e19e",
    x1: 244.61,
    y1: 444.81,
    x2: 261.8,
    y2: 437.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "a0fc879a-3486-4fa4-b098-48d40753e19e",
    x1: 283.97,
    y1: 450.57,
    x2: 275.46,
    y2: 498.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "a0fc879a-3486-4fa4-b098-48d40753e19e",
    x1: 270.81,
    y1: 442.56,
    x2: 261.8,
    y2: 491.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "a0fc879a-3486-4fa4-b098-48d40753e19e",
    x1: 257.07,
    y1: 439.21,
    x2: 247.63,
    y2: 483.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "a0fc879a-3486-4fa4-b098-48d40753e19e",
    x1: 226.24,
    y1: 436.06,
    x2: 266.31,
    y2: 429.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "a0fc879a-3486-4fa4-b098-48d40753e19e",
    x1: 221.33,
    y1: 421.02,
    x2: 267.32,
    y2: 416.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "afee8757-e023-471b-9325-5d980bdde616",
    d: "M316.55,433.69s103.08-49.95,193-35.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "afee8757-e023-471b-9325-5d980bdde616",
    d: "M638.75,409.32s132.94-24.54,210.3,40.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "afee8757-e023-471b-9325-5d980bdde616",
    d: "M815.53,412.12S712.3,388.65,638.75,433.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "afee8757-e023-471b-9325-5d980bdde616",
    d: "M512.44,413.29s-121.2-24-205.14-11.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "afee8757-e023-471b-9325-5d980bdde616",
    d: "M944.64,351.45s12.83,23.18,37.8,1.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a3379629-1197-4a42-a184-ef9060cb9c2f",
    d: "M137.82,552l24.12-5.1c4.59-1,7.1-7.15,4.26-10.5l-21.11-25a5.64,5.64,0,0,1-1.11-4.54l5-31.42c.8-5-3.91-7.89-8-4.89l-25,18.34a5.65,5.65,0,0,1-4.54,1.09l-34.18-7.88c-4.28-1-8.62,4.07-7.39,8.6l7.23,26.46a7.23,7.23,0,0,1-2.17,6.94L53.79,544c-3.76,3.54-2.9,9.62,1.46,10.34l38,.89A4.37,4.37,0,0,1,96.05,557l18.16,33.35c2.63,3.56,8.44,1.54,9.86-3.42l8.57-29.79A7.25,7.25,0,0,1,137.82,552Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f41a863a-6f5c-40d2-9f54-41949b923797",
    d: "M153.11,690.27l3.48-8.8c.67-1.68-.78-3.79-2.46-3.6l-12.48,1.47a2.15,2.15,0,0,1-1.68-.6l-9-8.27a1.88,1.88,0,0,0-3.27,1.53l.58,11.9a2.14,2.14,0,0,1-.62,1.69l-9.76,9.28c-1.23,1.16-.53,3.62,1.18,4.19l10,3.29a2.79,2.79,0,0,1,1.77,2.17l1.89,11c.34,2,2.47,3,3.62,1.72l8.34-12a1.63,1.63,0,0,1,1.15-.54L160.38,706c1.7-.09,2.29-2.37,1-3.89L153.65,693A2.81,2.81,0,0,1,153.11,690.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a3379629-1197-4a42-a184-ef9060cb9c2f",
    d: "M1029.6,524l3.31-8.36c.62-1.59-.75-3.6-2.34-3.41l-11.85,1.39a2,2,0,0,1-1.6-.57l-8.56-7.85a1.78,1.78,0,0,0-3.1,1.45l.55,11.3a2,2,0,0,1-.58,1.6l-9.28,8.81c-1.16,1.11-.5,3.45,1.13,4l9.5,3.13a2.66,2.66,0,0,1,1.68,2.06l1.79,10.43c.32,1.86,2.35,2.82,3.44,1.63l7.92-11.37a1.58,1.58,0,0,1,1.09-.51l13.81,1.19c1.61-.09,2.16-2.26.94-3.69l-7.34-8.6A2.66,2.66,0,0,1,1029.6,524Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a06a5c7a-1320-4040-bd73-2ba9f7592d7f",
    d: "M1113.48,658.84l21-4.44c4-.85,6.19-6.24,3.72-9.17l-18.42-21.78a4.91,4.91,0,0,1-1-4l4.36-27.41c.69-4.37-3.42-6.88-7-4.26l-21.81,16a4.9,4.9,0,0,1-4,1l-29.81-6.87c-3.73-.87-7.52,3.54-6.44,7.49l6.3,23.08a6.29,6.29,0,0,1-1.89,6l-18.42,17.35c-3.28,3.09-2.53,8.39,1.27,9l33.12.77a3.87,3.87,0,0,1,2.47,1.51l15.83,29.09c2.3,3.1,7.36,1.34,8.61-3l7.47-26A6.3,6.3,0,0,1,1113.48,658.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a06a5c7a-1320-4040-bd73-2ba9f7592d7f",
    d: "M687.85,540.13l-15.63-22.06c-2.6-3.68-8-3.67-9.1,0l-5.36,32.69a3.83,3.83,0,0,1-1.84,2.24l-31,11.65c-3.39,1.85-2.35,7.1,1.77,8.93l23.11,10.3a6.33,6.33,0,0,1,3.78,5.09l1.66,23.87c.28,4.09,5.31,7,8.56,4.95l25.87-16.31a4.86,4.86,0,0,1,4.05-.41L719.59,609c4.23,1.29,7.29-2.43,5.19-6.33l-13.15-24.44a4.88,4.88,0,0,1-.4-4.05l10.2-26.64c1.37-3.58-2.47-7.95-6.53-7.43l-21.32,2.74A6.3,6.3,0,0,1,687.85,540.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f41a863a-6f5c-40d2-9f54-41949b923797",
    d: "M365.5,29.47,362.6,8.3c-.55-4-5.73-6.59-8.81-4.34L330.87,20.65a4.86,4.86,0,0,1-4,.67L300,15c-4.29-1-7.07,2.89-4.73,6.62l14.29,22.77a4.84,4.84,0,0,1,.66,4l-8.94,29.05c-1.12,3.64,3,7.71,7,6.93l23.33-4.6a6.29,6.29,0,0,1,5.86,2.31l15.87,19.5c2.83,3.48,8.14,3.11,9-.62l3.14-32.76a3.8,3.8,0,0,1,1.67-2.34l30-13.62c3.24-2.05,1.86-7.2-2.34-8.74l-25.22-9.27A6.3,6.3,0,0,1,365.5,29.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a615e823-a398-4d53-9b12-86459fb2ce52",
    d: "M759.75,216.6c0-104-84.3-188.29-188.29-188.29A188.32,188.32,0,0,0,507.1,393.6h0c6.71,8.19,5.37,13.46,5.35,19.69a50,50,0,0,1-3.62,18.18c-16,40.49-6.58,87.46-6.58,87.46h0a50.91,50.91,0,0,0,73.21,38.74h0s.26-.12.75-.39a50.87,50.87,0,0,0,10.45-7.24c18.79-15.3,54.37-56.2,51.53-145.16a26.67,26.67,0,0,1,14.08-18.19h0A188.3,188.3,0,0,0,759.75,216.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a0fc879a-3486-4fa4-b098-48d40753e19e",
    d: "M808.79,189.67s-36.13,9.41-49,26.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a0fc879a-3486-4fa4-b098-48d40753e19e",
    d: "M783.61,368.53c-2.49,11.32-31.56,4.93-29.07-6.4,0,8.23-33.72,8.23-33.72,0q-13.52,5.34-18-10.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a3379629-1197-4a42-a184-ef9060cb9c2f",
    d: "M206.27,433.69S103.5,459.3,10.15,408.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a3379629-1197-4a42-a184-ef9060cb9c2f",
    d: "M955.32,460s124.63,21.08,196.54-29.62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a615e823-a398-4d53-9b12-86459fb2ce52",
    cx: 576.15,
    cy: 405.74,
    r: 12.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "a0fc879a-3486-4fa4-b098-48d40753e19e",
    d: "M50.45,289.42a159.49,159.49,0,1,1,261.26,98.52h0s-9.31,9.39-.92,31.47C320,447.19,368.55,523,296.9,559.92s-76.28-84.06-81.3-100.8-9.24-29.22-16.07-33.34h0A159.55,159.55,0,0,1,50.45,289.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a0fc879a-3486-4fa4-b098-48d40753e19e",
    d: "M775.15,246.61A159.49,159.49,0,1,1,963.84,452.42h0s-12.54,4.18-15,27.67c-4.31,29,4.8,118.49-75.8,119.12S842.88,489.77,846,472.57s4.93-30.25.69-37h0A159.53,159.53,0,0,1,775.15,246.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a0fc879a-3486-4fa4-b098-48d40753e19e",
    d: "M728.79,506.42c-3.18-11.95.2-25.06,8.43-32.7l72.6-67.41A160.18,160.18,0,0,1,770,329.05l-38.54-13.16a189.1,189.1,0,0,1-79.18,70.81h0a26.67,26.67,0,0,0-14.08,18.19c2.84,89-32.74,129.86-51.53,145.16a50.87,50.87,0,0,1-10.45,7.24c-.49.27-.75.39-.75.39h0a50.91,50.91,0,0,1-73.21-38.74h0s-9.44-47,6.58-87.46a50,50,0,0,0,3.62-18.18c0-6.23,1.36-11.5-5.35-19.69h0a188.94,188.94,0,0,1-97-80l-56.3,18.24a160.43,160.43,0,0,1-38.9,53.29,28.55,28.55,0,0,0,5.13,6.67L412,480c8.11,7.77,11.29,20.93,7.92,32.83l-36.67,129.7c-6.54,23.11,11.41,45.28,30.53,37.71l153.42-87.13a20.26,20.26,0,0,1,15.41.12l152,89.55c19,7.87,37.29-14,31.12-37.23Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtendedFamily);
export default __webpack_public_path__ + "static/media/extended-family.23f9d1f478d7e80cbe171c6d4bf5851e.svg";
export { ForwardRef as ReactComponent };